// 后端按钮接口已停用：导航、页脚与社交入口使用组件内静态默认值。
const empty = () => Promise.resolve({ data: [] })

export const getButtonList = empty
export const getNavButtons = empty
export const getShortcutButtons = empty
export const getFooterButtons = empty
export const getSocialButtons = empty
